// Portal version + release notes shown in the top-nav badge.
// Source of truth is releases.json (also read by the backend on startup to
// announce new deployments in Slack #portal-debugging-uk).
// Bump "version" and prepend a release entry with every deployment.
import releasesData from "./releases.json";

export const APP_VERSION = releasesData.version;
export const RELEASES = releasesData.releases;
